import ClientTicketViewLayout from "layouts/client-ticket-view";
import { getClientAccessToken, getClientSession } from "utils/clientSession";
import { Navigate } from "react-router-dom";

export default function ClientTicketView() {
  const session = getClientSession();
  const accessToken = getClientAccessToken();

  if (!session || !accessToken) {
    return <Navigate to="/login" replace />;
  }

  return <ClientTicketViewLayout clientAccessToken={accessToken} />;
}
